export default {
      id: "icon-arrow-up-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.svg#icon-arrow-up",
      toString: function () {
        return this.url;
      }
    }